export default __webpack_public_path__ + "static/media/lock.2e533733.svg";